import React from 'react'

/**
 * Context for providing puck config to the break player.
 * breaktime-theme defines the context (null default).
 * Child sites (e.g. dailybreak-site) provide the value via gatsby-browser.js wrapRootElement.
 */
export const PuckConfigContext = React.createContext(null)
